/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Open_Knp_LookupInputs */

const en_open_knp_lookup = /** @type {(inputs: Open_Knp_LookupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open KNP terminology lookup`)
};

const fr_open_knp_lookup = /** @type {(inputs: Open_Knp_LookupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ouvrir la recherche terminologique KNP`)
};

const de_open_knp_lookup = /** @type {(inputs: Open_Knp_LookupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KNP-Terminologie-Lookup öffnen`)
};

const it_open_knp_lookup = /** @type {(inputs: Open_Knp_LookupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apri la ricerca terminologica KNP`)
};

const ru_open_knp_lookup = /** @type {(inputs: Open_Knp_LookupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Откройте поиск терминов КНП`)
};

const es_open_knp_lookup = /** @type {(inputs: Open_Knp_LookupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir la búsqueda de terminología de KNP`)
};

const zh_cn2_open_knp_lookup = /** @type {(inputs: Open_Knp_LookupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打开 KNP 术语查询`)
};

const ja_open_knp_lookup = /** @type {(inputs: Open_Knp_LookupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KNP用語検索を開く`)
};

const hi_open_knp_lookup = /** @type {(inputs: Open_Knp_LookupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ओपन केएनपी शब्दावली खोज`)
};

const pt_pt2_open_knp_lookup = /** @type {(inputs: Open_Knp_LookupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consulta de terminologia KNP aberta`)
};

/**
* | output |
* | --- |
* | "Open KNP terminology lookup" |
*
* @param {Open_Knp_LookupInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const open_knp_lookup = /** @type {((inputs?: Open_Knp_LookupInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Open_Knp_LookupInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_open_knp_lookup(inputs)
	if (locale === "de") return de_open_knp_lookup(inputs)
	if (locale === "it") return it_open_knp_lookup(inputs)
	if (locale === "ru") return ru_open_knp_lookup(inputs)
	if (locale === "es") return es_open_knp_lookup(inputs)
	if (locale === "zh-CN") return zh_cn2_open_knp_lookup(inputs)
	if (locale === "ja") return ja_open_knp_lookup(inputs)
	if (locale === "hi") return hi_open_knp_lookup(inputs)
	if (locale === "pt-PT") return pt_pt2_open_knp_lookup(inputs)
	return en_open_knp_lookup(inputs)
});